import { forwardRef, type Ref, type SVGProps } from "react";
const IconCommuteOutlineSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.002 18.801a4 4 0 0 1 4.002 4C10.004 26 6.002 30 6.002 30 5.977 29.975 2 25.99 2 22.8a4 4 0 0 1 4.002-3.999m0 2.4a1.601 1.601 0 1 0 .001 3.202 1.601 1.601 0 0 0-.001-3.202"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      d="M23.437 2.542a1.855 1.855 0 0 1 2.622 0l3.64 3.638a1.029 1.029 0 1 1-1.457 1.455L26.065 5.46l.077 10.084a6.753 6.753 0 0 1-6.916 6.75c-3.666-.089-6.594-4.085-6.594-7.75V8.68a3.09 3.09 0 0 0-6.18 0v7.316a1.225 1.225 0 0 1-2.45 0V8.68a5.54 5.54 0 0 1 5.37-5.533 5.54 5.54 0 0 1 5.71 5.533v5.864c0 2.336 1.866 5.245 4.203 5.301a4.304 4.304 0 0 0 4.407-4.301l-.098-10.247-2.34 2.338a1.03 1.03 0 0 1-1.457-1.455z"
    />
  </svg>
);
const ForwardRef = forwardRef(IconCommuteOutlineSVG);
ForwardRef.displayName = "IconCommuteOutline";
export { ForwardRef as IconCommuteOutline };
